import type { Profile } from '../../lib/types';

// Single source of truth for the per-task "reward" emoji that lights the
// star shelf and renders on the celebration screen. Phase 1 always returns
// '⭐'; phase 2 will swap to a per-profile field on Profile so parents can
// pick poop / unicorn / heart / etc. without touching shelf, fly-star, or
// celebration code.
export function getRewardEmoji(profile: Profile): string {
  void profile;
  return '⭐';
}
